import { render, staticRenderFns } from "./bgImgContainer.vue?vue&type=template&id=45ed6d58&scoped=true&"
import script from "./bgImgContainer.vue?vue&type=script&lang=ts&"
export * from "./bgImgContainer.vue?vue&type=script&lang=ts&"
import style0 from "./bgImgContainer.vue?vue&type=style&index=0&id=45ed6d58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ed6d58",
  null
  
)

export default component.exports